import { api, tokenStore } from "./apiClient";

export const authService = {
  async login(identifier, password) {
    const body = typeof identifier === "string" ? { email: identifier } : identifier;
    const { data } = await api.post("/auth/login", { ...body, password });
    if (data.requires_2fa || data.requires_2fa_setup) return data;
    tokenStore.set(data.access_token);
    return { user: data.user };
  },
  async register(payload) {
    const { data } = await api.post("/auth/register", payload);
    tokenStore.set(data.access_token);
    return data.user;
  },  async setTheme(theme) {
    const { data } = await api.patch("/users/me/theme", { theme });
    return data;
  },
  async setLanguage(language) {
    const { data } = await api.patch("/users/me/language", { language });
    return data;
  },
  async me() {
    const { data } = await api.get("/auth/me");
    return data;
  },
  async logout() {
    try {
      await api.post("/auth/logout");
    } finally {
      tokenStore.clear();
    }
  },
  async overview() {
    const { data } = await api.get("/users/me/overview");
    return data;
  },
};
